import { observable, IObservableArray, flow, toJS } from 'mobx';
import API from 'api';
import Query from 'utilities/Query';
import * as yup from 'yup';

export default class ItemReminder {
	@observable id: number;
	@observable productName: string = '';
	@observable therapeuticArea: string = '';
	@observable therapeuticAreaID: number = '';
	@observable scheduleType: number = '';
	@observable schedule: number = '';
	@observable itemCodes: string = '';
	@observable created: string;
	@observable disabled: boolean = false;

	constructor(data: JSON = null) {
		if (data) this.extend(data);
	}

	extend(data: JSON) {
		Object.assign(this, data);
	}

	update = flow(function*(withData) {
		if (withData) this.extend(withData);
		yield ItemReminder.ValidationSchemaItemReminder.validate(toJS(this), {
			abortEarly: false
		});
		this.modified = new Date();
		if (this.id) {
			// Update record
			yield API.patch(`/ItemReminders/${this.id}`, toJS(this));
		} else {
			// New record
			this.created = new Date();
			let result = yield API.post(`/ItemReminders`, toJS(this));
			this.id = result.id;
		}
	});

	static ValidationSchemaItemReminder = yup.object().shape({
		therapeuticAreaID: yup
			.number()
			.label('Therapeutic Area')
			.typeError('Therapeutic Area is a required field')
			.positive('Therapeutic Area is a required field')
			.required(),
		productName: yup
			.string()
			.label('Drug Name')
			.required(),
		schedule: yup
			.number()
			.typeError('Reminder schedule is a required field')
			.label('Reminder schedule')
			.required(),
		scheduleType: yup
			.number()
			.typeError('Schedule type (days/weeks/months) is a required field')
			.label('Schedule type (days/weeks/months) a required field')
			.required()
	});

	static loadItemReminders(
		query?: Query
	): Promise<{ itemCount: number, items: Array<ItemReminder> }> {
		if (!query) {
			query = new Query();
			query.pageSize = 1000;
		}
		return new Promise((resolve, reject) => {
			API.get(`/ItemReminders/items/${query.toToLpQueryUrl()}`)
				.then(result => {
					let res = {
						itemCount: result.count,
						items: result.items.map(el => new ItemReminder(el))
					};
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	}

	static loadById = async (id: number): Promise<ItemReminder> => {
		let res = await API.get(`/ItemReminders/${id}`);
		return new ItemReminder(res);
	};
}



// WEBPACK FOOTER //
// ./src/stores/ItemReminder.js